import React, { lazy } from "react";
import { BC_REPORTS } from "app_constants";
import { DashboardIcon } from "components/icons/DashboardIcon";
import {
  DateRangeSupport,
  QueryParamDateFormat,
  formatForQueryParams,
} from "helpers/shared/formatters/dates";

import type { ISectionProps } from "types/navigation";

const DASHBOARD: ISectionProps = {
  feature: "Dashboard",
  icon: <DashboardIcon />,
  app: BC_REPORTS,
  path: "/dashboard",
  component: lazy(() =>
    import("containers/dashboard/Dashboard").then((module) => ({
      default: module.DashboardContainer,
    }))
  ),
  subSections: [],
  legacyPath: ({ startDate, endDate }) => {
    return `/reports/sales?startDate=${formatForQueryParams(
      startDate,
      QueryParamDateFormat.BREADCRUMB
    )}&endDate=${formatForQueryParams(
      endDate,
      QueryParamDateFormat.BREADCRUMB
    )}`;
  },
  level: ["store"],
  dateSupport: DateRangeSupport.FULL,
};

export default DASHBOARD;
